import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed2ee400"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "data-testid"]
const _hoisted_2 = { class: "app-icon p-2" }
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = {
  class: "app-sub-label",
  "data-testid": "origin"
}
const _hoisted_5 = {
  class: "app-created-at",
  "data-testid": "created-at"
}
const _hoisted_6 = { class: "remove is-flex is-align-items-center" }

import { ref, computed } from 'vue'

import { useAppStore } from '@/popup/store/AppStore'
import { InternalMethods } from '@/shared/apis/messages'
import Picture from '@/popup/components/shared/Picture.vue'
import DisconnectAppModal from '@/popup/components/Modal/DisconnectApp.vue'
import Scroll from '@/popup/components/shared/Scroll/Scroll.vue'
import { useUIStore } from '@/popup/store/UIStore'
import { useGlobals } from '@/popup/compositions/useGlobals'
import Icon3 from '@/assets/compass-outline.png'
import { logError } from '@/shared/logger'
import { truncateMiddle } from '@/shared/utils'
import { d } from '@/popup/lib/i18n'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import ModalTransition from '@/popup/components/shared/Modal/ModalTransition.vue'
import { AuthenticatedApp } from '@/shared/models/AuthenticatedApp'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthenticatedApps',
  setup(__props) {

const appStore = useAppStore()
const uiStore = useUIStore()
const modalOpen = ref(false)
const originForModal = ref('')

const sort = (apps: AuthenticatedApp[]) => {
  return apps.sort((a, b) => {
    if (!a.createdAt || !b.createdAt) {
      return 0
    }

    if (a.createdAt > b.createdAt) {
      return -1
    } else if (a.createdAt < b.createdAt) {
      return 1
    } else {
      return 0
    }
  })
}

const authenticatedApps = computed(() => sort(appStore.authenticatedApps))

const showAuthenticatedApps = computed(
  () =>
    uiStore.currentTab === 'AUTHENTICATED' &&
    appStore.authenticatedApps.length > 0
)

const openModal = (label: string) => {
  originForModal.value = label
  modalOpen.value = true
}

const closeModal = () => {
  modalOpen.value = false
}

const deleteApp = async () => {
  try {
    closeModal()
    await useGlobals().sendMessage({
      method: InternalMethods.REMOVE_AUTHENTICATED_APP,
      payload: { origin: originForModal.value },
    })
  } catch (error) {
    logError(`Error while removing authenticated app:`, error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(Scroll, { class: "px-4 pt-4" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(authenticatedApps.value, ({ origin, icon, name, createdAt }) => {
          return (_openBlock(), _createElementBlock("div", {
            key: origin,
            class: "app is-flex is-justify-content-space-between mb-2 p-2",
            "data-testid": "app"
          }, [
            _createElementVNode("a", {
              href: origin,
              target: "_blank",
              rel: "noopener",
              referrerpolicy: "no-referrer",
              class: "is-flex is-align-items-center is-clickable",
              "data-testid": 'auth-' + name
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(Picture, {
                  "picture-url": icon || _unref(Icon3),
                  size: 24
                }, null, 8 /* PROPS */, ["picture-url"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(truncateMiddle)(encodeURI(origin.replace(/^https?:\/\//, '')), 15)), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_5, _toDisplayString(`${_unref(d)(createdAt, 'longDate')} @ ${_unref(d)(createdAt, 'time')}`), 1 /* TEXT */)
              ])
            ], 8 /* PROPS */, _hoisted_1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(SvgIcon, {
                class: "remove-button",
                height: "24",
                width: "24",
                color: "var(--neutral-70)",
                "secondary-color": "transparent",
                name: "cross-outline",
                "data-testid": "remove-modal",
                onClick: ($event: any) => (openModal(encodeURI(origin)))
              }, null, 8 /* PROPS */, ["onClick"])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 512 /* NEED_PATCH */), [
      [_vShow, showAuthenticatedApps.value]
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(ModalTransition, null, {
        default: _withCtx(() => [
          (modalOpen.value)
            ? (_openBlock(), _createBlock(DisconnectAppModal, {
                key: 0,
                origin: originForModal.value,
                "on-confirm": deleteApp,
                "on-cancel": closeModal,
                "data-testid": "modal"
              }, null, 8 /* PROPS */, ["origin"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})